<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="aa_em_name,aa_code"
      placeholder="请输入单号或者申请人名称"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/auth_apply/'+ item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.aa_module_name}}</p>
          <p>{{ item.aa_em_name }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.aa_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.aa_status!='已审核'}"
          >{{item.aa_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}台</label>
    </div>
    <add-button to="/oa/auth_apply_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/authApply/list",
      filters: [
       {
          type: "date",
          name: "createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "aa_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "aa_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>